import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { SiteConfigureComponent } from 'src/app/view/site-configure/site-configure.component';
import { HourlyConfigModalComponent } from '../../shared/component/hourly-config-modal/hourly-config-modal.component';
import { DayAheadMarketModule } from '../day-ahead-market/day-ahead-market.module';
import { RealTimeMarketModule } from '../real-time-market/real-time-market.module';
import { SiteEventsModule } from '../site-events/site-events.module';

@NgModule({
  declarations: [SiteConfigureComponent, HourlyConfigModalComponent],
  exports: [SiteConfigureComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    SiteEventsModule,
    DayAheadMarketModule,
    RealTimeMarketModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
})
export class SiteConfigureModule {}
